import { css } from 'styled-components';

/**
 * Width of the blog sidebar callout. Used for both the callout's width and the
 * negative margin so the pull-out exactly matches the callout width. Single
 * source of truth for this layout.
 *
 * Why 16rem works: at xl (1440px) the article is 40rem (640px) and centered,
 * so the right margin is (1440 - 640) / 2 = 400px. Callout (16rem = 256px) +
 * gutter (spacing[2] = 2rem = 32px) = 288px, which fits in that 400px. A larger
 * width would overflow the margin.
 */
const SIDEBAR_CALLOUT_WIDTH = '16rem';

/**
 * Float a sidebar callout into the right margin on xl viewports so article
 * text stays full width. Use for components that sit in the blog article
 * sidebar (e.g. Subscribe, other callouts).
 *
 * Pulls the element outside the article's max-width boundary. The negative
 * margin equals the callout width (SIDEBAR_CALLOUT_WIDTH) plus a gutter, so
 * the float's effective in-flow width is ≤ 0 and body text does not wrap
 * around the card.
 */
/* TODO: apply to the SidebarCallout component when available */
export const sidebarCalloutFloatXl = css`
  ${({ theme }) => theme.mq.minWidth.xl} {
    float: right;
    clear: right;
    width: ${SIDEBAR_CALLOUT_WIDTH};
    margin-inline-end: calc(
      -${SIDEBAR_CALLOUT_WIDTH} - ${({ theme }) => theme.spacing[2]}
    );
    margin-block: 0 ${({ theme }) => theme.spacing[2]};
  }
`;
